var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoun6357415(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#FFFFFF",
    viewBox: "0 0 32 40",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,1.5h-6.959c-.829,0-1.5,.671-1.5,1.5s.671,1.5,1.5,1.5h6.959c.276,0,.5,.224,.5,.5V27c0,.276-.224,.5-.5,.5H5c-.276,0-.5-.224-.5-.5V13.96c0-.829-.671-1.5-1.5-1.5s-1.5,.671-1.5,1.5v13.04c0,1.93,1.57,3.5,3.5,3.5H27c1.93,0,3.5-1.57,3.5-3.5V5c0-1.93-1.57-3.5-3.5-3.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 15,
    height: 8.92,
    rx: 3,
    ry: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.899,16c0-.829-.671-1.5-1.5-1.5h-6.399c-.194,0-.378,.04-.548,.107-.007,.003-.015,.004-.022,.007-.37,.152-.665,.447-.817,.817-.003,.007-.004,.015-.007,.022-.067,.17-.107,.354-.107,.548v6.399c0,.829,.671,1.5,1.5,1.5s1.5-.671,1.5-1.5v-2.778l6.464,6.464c.293,.293,.677,.439,1.061,.439s.768-.146,1.061-.439c.586-.585,.586-1.536,0-2.121l-6.464-6.464h2.778c.829,0,1.5-.671,1.5-1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoun6357415);
export default __webpack_public_path__ + "static/media/noun-6357415.799a153897cb503e5b3d2312738a786d.svg";
export { ForwardRef as ReactComponent };